<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} Đơn vị cung cấp
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form ref="myForm" label-position="top" @submit.native.prevent
                :model="mData.tableRules.dataSearch.value" :rules="mData.tableRules.dataSearch.valid">
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Mã số tài khoản" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['du_lieu_khai_bao.user_account']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Tên đơn vị" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['thong_tin_chung.ten']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Loại điểm đến" prop="">
                      <el-select v-model="mData.tableRules.dataSearch.value.loai_diem_den" :placeholder="aLang.c_select"
                        clearable filterable>
                        <el-option v-for="item in mData.dataDefault.listLoaiHinh" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <!-- <b-col md="3">
                    <el-form-item label="Trạng thái">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value['duyet.duoc_duyet']
                        "
                        :placeholder="aLang.c_select"
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listTrangThai"
                          :key="item.code"
                          :value="item.code"
                          :label="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col> -->
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button type="info" native-type="submit" v-ladda plain
                    @click="fn_tableSearch()">{{ aLang.c_search }}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{ aLang.c_showHideSearch }}</el-button>
              <!-- <el-button @click="fn_handle('create')" v-if="mData.ifHaveCreate" type="info" plain>{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>
        <b-row v-if="mData.dataDefault.error">
          <b-col md="12" class="mb-2">
            <el-alert :title="mData.dataDefault.error" type="error" show-icon></el-alert>
          </b-col>
        </b-row>
        <el-table :data="mData.tableRules.data" border @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange" max-height="440" style="width: 100%" :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }">
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>

          <el-table-column prop="du_lieu_khai_bao.user_account" :sortable="mData.tableRules.allowSorting"
            label="Mã số tài khoản" align="center" width="150"></el-table-column>
          <el-table-column prop="du_lieu_khai_bao.user_ten" :sortable="mData.tableRules.allowSorting" label="Tên đơn vị"
            min-width="180"></el-table-column>
          <el-table-column prop="ten_loai_diem_den" :sortable="mData.tableRules.allowSorting" label="Loại điểm đến"
            min-width="130"></el-table-column>
          <el-table-column prop="du_lieu_khai_bao.giay_to_so_giay_to" :sortable="mData.tableRules.allowSorting"
            label="Mã số thuế" min-width="120"></el-table-column>
          <el-table-column prop="du_lieu_khai_bao.user_dia_chi" :sortable="mData.tableRules.allowSorting"
            label="Địa chỉ" min-width="180"></el-table-column>
          <el-table-column prop="thoi_diem_tao" :sortable="mData.tableRules.allowSorting"
            :formatter="fn_formatterDatetime" label="Thời điểm đăng ký" width="160" align="center"></el-table-column>
          <!-- <el-table-column
            prop="duyet.duocduyet"
            :sortable="mData.tableRules.allowSorting"
            label="Trạng thái"
            v-if="!aRole('VNATAdmin')"
            width="90"
            align="center"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.duyet.duoc_duyet"
                @change="
                  fn_changeTrangThaiDuyet(
                    scope.row.id,
                    scope.row.duyet.duoc_duyet,
                    scope.row.nguoi_tao_id
                  )
                "
              ></el-checkbox>
            </template>
          </el-table-column> -->
          <el-table-column prop="duyet.duoc_duyet" label="Trạng thái" :sortable="mData.tableRules.allowSorting">
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.row.duyet.duoc_duyet == true ? 'Đã duyệt' : 'Chưa duyệt' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="120px">
            <template slot-scope="scope">
              <el-button size="mini" @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail">
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update">
                <i class="icon-pencil icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick" :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit" :current-page="mData.tableRules.page" background
              layout="total, sizes, prev, pager, next, jumper" :total="mData.tableRules.total"
              :pager-count="5"></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DDATModel from "./DDATModel";
import DDATApi from "../../../moduleApi/DDATApi";
import AccountApi from "../../../moduleApi/AccountApi";
import DistrictApi from '../../../moduleApi/DistrictApi';
import CommuneApi from '../../../moduleApi/CommuneApi';
import ProvinceApi from '../../../moduleApi/ProvinceApi';

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DDAT", //requied
        moduleNameUpdate: "ThongTinDDAT", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(DDATModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listLoaiDDAT: DataService.loaiHinhRegister,
          listTrangThai: [
            {
              code: "true",
              text: "Đã duyệt",
            },
            {
              code: "false",
              text: "Chưa duyệt",
            },
          ],
          listLoaiHinh: [
            {
              value: "hotel",
              label: 'Khách sạn'
            },
            {
              value: "tourist_villa",
              label: 'Biệt thự du lịch'
            },
            {
              value: "tourist_apartment",
              label: 'Căn hộ du lịch'
            },
            {
              value: "tourist_cruise",
              label: 'Tàu thuỷ lưu trú du lịch'
            },
            {
              value: "motel",
              label: 'Nhà nghỉ du lịch'
            },
            {
              value: "homestay",
              label: 'Nhà ở có phòng cho khách du lịch thuê / Homestay'
            },
            {
              value: "restaurant",
              label: 'Nhà hàng'
            },
            {
              value: "entertainment",
              label: 'Điểm vui chơi, giải trí'
            }
          ],
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          isDistrictDisabled: true,
          isCommuneDisabled: true,
          error: "",
        },
      },
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch,
          },
        }).catch(() => { });
      }
      let res = await DDATApi.list(dataFilter);
      this.mData.tableRules.data = this.changeData(res.result);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      data.forEach((item) => {
        let tenLoai = this.mData.dataDefault.listLoaiDDAT.find(
          (element) => element.code == item.loai_diem_den
        );
        if (tenLoai) {
          item.ten_loai_diem_den = tenLoai.text;
        } else {
          item.ten_loai_diem_den = "";
        }
      });
      return data;
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-updateSafeplace",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => { });
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => { });
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => { });
      }
      if (type == "import") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-import",
          params: {},
        });
      }
    },

    //delete
    async fn_delete(id) {
      await DDATApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id) {
      await AccountApi.disable(id);
    },
    //event table

    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );

          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue) {
      let roles = "";
      cellValue.forEach((item) => {
        for (const element of this.mData.dataDefault.roles) {
          if (item == element.value) {
            item = element.label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() { },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },

    changeProvince(province, clear = true) {
      this.getDistrictList(province);
      this.mData.dataDefault.listCommune = [];
      this.mData.dataDefault.isDistrictDisabled = false;
      this.mData.dataDefault.isCommuneDisabled = true;
      if (clear) {
        this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.huyen_id'] = null;
        this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.xa_id'] = null;
      }
    },

    clearProvince() {
      this.mData.dataDefault.listDistrict = [];
      this.mData.dataDefault.listCommune = [];
      this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.huyen_id'] = null;
      this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.xa_id'] = null;
    },

    changeDistrict(district, clear = true) {
      this.getCommuneList(district);
      if (clear) {
        this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.xa_id'] = null;
      }
    },

    clearDistrict() {
      this.mData.dataDefault.listCommune = [];
      this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.xa_id'] = null;
    },

    async getProvinceList() {
      let province = await ProvinceApi.list({ limit: 1000 });
      if (province.result.length > 0) {
        this.mData.dataDefault.listProvince = province.result;
      }
    },

    async getDistrictList(provinceId) {
      let district = await DistrictApi.list({ filters: [`provinceId=${provinceId}`], limit: 1000 });
      if (district.result.length > 0) {
        this.mData.dataDefault.listDistrict = district.result;
      }
    },

    async getCommuneList(districtId) {
      let commune = await CommuneApi.list({ filters: [`districtId=${districtId}`], limit: 1000 });
      if (commune.result.length > 0) {
        this.mData.dataDefault.listCommune = commune.result;
      }
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
    this.getProvinceList();
  },
  mounted() {
    this.fn_initTable();

    // if (this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.tinh_id']){
    //   this.changeProvince(this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.tinh_id'], false);
    // }
    // if (this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.huyen_id']){
    //   this.changeDistrict(this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.dia_chi.huyen_id'], false);
    // }
  },
};
</script>
